"use strict";
import decode_auth_token from '../decodeAuthToken';

const isPrimaryCampaign = (campaign_id = null) => {
    try {
        const user = decode_auth_token();
        if (user.campaigns) {
            let cp_id = campaign_id ? campaign_id : app.activeSingleCampaign ? app.activeSingleCampaign : null;
            if (cp_id) {
                let campaign = user.campaigns.filter(c => c.id == cp_id);
                if (campaign[0]) {
                    return campaign[0].primary;
                }
            }
        }
        return false;
    } catch (err) {
        console.log('RMS', err);
        return false;
    }
}

export default isPrimaryCampaign;
